import { IOrder } from "src/function/ordersService";
import { CLEAR_ORDERS, GET_ORDERS, SET_ORDER_DATA, SET_ORDERS } from "../constans";

export interface OrdersState {
  orders: IOrder[]
}

interface SetOrdersAction {
  type: typeof SET_ORDERS;
  payload: IOrder[];
}

interface SetOrderDataAction {
  type: typeof SET_ORDER_DATA;
  payload: {
    socketId: string,
    statusOrder: string
  };
}

interface GetOrdersAction {
  type: typeof GET_ORDERS;
}

interface ClearOrdersAction {
  type: typeof CLEAR_ORDERS;
}

type OrdersActionTypes = SetOrdersAction | GetOrdersAction | ClearOrdersAction | SetOrderDataAction;

const initialState: OrdersState = {
  orders: []
};

export const ordersReduser = (state = initialState, action: OrdersActionTypes): OrdersState => {
  switch (action.type) {
    case SET_ORDERS:
      return {
        ...state,
        orders: action.payload
      };

    case SET_ORDER_DATA:
      return {
        ...state,
        orders: state.orders.map(order =>
          order.socketId === action.payload.socketId
            ? { ...order, statusOrder: action.payload.statusOrder }
            : order
        ),
      };

    case GET_ORDERS:
      return state

    case CLEAR_ORDERS:
      return {
        ...state,
        orders: []
      }

    default:
      return state;
  }
}

export const SetOrders = (orders: IOrder[]) => ({
  type: SET_ORDERS,
  payload: orders
});

export const GetOrders = () => ({
  type: GET_ORDERS
});

export const clearOrders = () => ({
  type: CLEAR_ORDERS
})

export const updateOrderStatus = (socketId: string, statusOrder: string) => ({
  type: SET_ORDER_DATA,
  payload: {
    socketId,
    statusOrder
  }
});
